import { createFileRoute } from '@tanstack/react-router';

import { PoliticaPrivacidadPage } from '@/pages/politica-privacidad';

export const Route = createFileRoute('/_public/privacidad')({
  component: PoliticaPrivacidadPage,
});
